(function () {
    'use strict';

    angular.module('app').component('corporateBenefitGroupsCreateEditAccessibleTreatmentsComponent', {
        templateUrl: require('/App/corporate/views/benefitGroups/createEdit/accessibleTreatments/accessibleTreatments.component.html'),
        controller: controller,
        controllerAs: 'vm',
        bindings: {
            treatmentEditData: '<',
            isTreatmentTreeDirty: '=',
            isReadOnly: '<'
        }
    });

    function controller() {
        var vm = this;
    }
})();

